<template>
  <div>
  <!-- navbar -->
         <Navigation> </Navigation>
        <!-- navbar --> 
         <img src="imgs/img_background_bubbles2.png" class="img-fluid bubble-background " alt="" >
     <section class="home-container" id="home">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-7">
                    <!-- animation text - START -->
                    <div class="content">
                        <div class="content__container">
                            <p class="content__container__text">
                                Some
                            </p>

                            <ul class="content__container__list">
                                <li class="content__container__list__item">Text !</li>
                                <li class="content__container__list__item">Text !</li>
                                <li class="content__container__list__item">Text !</li>
                                <li class="content__container__list__item">Text !</li>
                            </ul>
                        </div>
                    </div>
                    <!-- animation text - END -->
                    <h3 class="display-4 home-main-text">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </h3>
                    <br>
                    <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the 1500s.</span>
                </div>

                <div class="col-lg-5 col-md-5">

                  <div v-if="canLogin === true">
                     <img src="imgs/ic_books_img.png" class="img-fluid mt-5 pt-5 " alt="" >
                  </div>
                    <h6 class="mt-5">Get started with your 10-days free trial</h6>
                    <div>
                        <input type="text" class="trial-form" placeholder="Email" />
                        <br>
                        <input type="text" class="mt-2 trial-form" placeholder="Password" />
                        <p>Powered by Aruvaa. Kindly read the terms of services before you proceed.</p>
                        <input type="checkbox" class="checkbox-form"> I agree to the <span class="terms-privacy-text"><a
                                href="">Terms of Services</a></span>
                        and <span class="terms-privacy-text"><a href="">Privacy Policy</a></span>
                        <br>
                        <br>
                        <a href="">
                            <button class="free-trial-btn">Start Free Trial</button>
                        </a>
                    </div>
                  
                </div>
            </div>
        </div>
     </section>
    <br>
    <br>
    <br>

<!-- svg -->
<!-- <img src="imgs/ic_books_img.png" class="img-fluid mt-5 pt-5 " alt="" > -->
  <svg id="clouds" class="cloud-divider" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100"
        viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M-5 100 Q 0 20 5 100 Z
						 M0 100 Q 5 0 10 100
						 M5 100 Q 10 30 15 100
						 M10 100 Q 15 10 20 100
						 M15 100 Q 20 30 25 100
						 M20 100 Q 25 -10 30 100
						 M25 100 Q 30 10 35 100
						 M30 100 Q 35 30 40 100
						 M35 100 Q 40 10 45 100
						 M40 100 Q 45 50 50 100
						 M45 100 Q 50 20 55 100
						 M50 100 Q 55 40 60 100
						 M55 100 Q 60 60 65 100
						 M60 100 Q 65 50 70 100
						 M65 100 Q 70 20 75 100
						 M70 100 Q 75 45 80 100
						 M75 100 Q 80 30 85 100
						 M80 100 Q 85 20 90 100
						 M85 100 Q 90 50 95 100
						 M90 100 Q 95 25 100 100
						 M95 100 Q 100 15 105 100 Z">
        </path>
    </svg>

    <div class="text-center p-4 catalog-section">
        <h5 class="text-white">Powered by Aruvaa. Kindly read the terms of services before you proceed.</h5>
        <div class="container text-white">
            <div class="row">
                <div class="col-lg-4 col-md-4 mt-5 text-left">
                    <h2 class="text-left display-4 mt-4">Lorem Ipsum is simply dummy text</h2> <br>
                    <span class=""><i class="fas fa-user-shield"></i> Some Text Here. Lorem ipsum is a dummy</span> <br>
                    <span class=""><i class="fas fa-user-shield"></i> Some Text Here</span> <br>
                    <span class=""><i class="fas fa-user-shield"></i> Some Text Here</span> <br>
                    <span class=""><i class="fas fa-user-shield"></i> Some Text Here</span> <br>
                    <span class=""><i class="fas fa-user-shield"></i> Some Text Here</span>

                </div>
                <div class="col-lg-8 col-md-8 mt-5">
                     <img src="imgs/img_product_pic.png" class="img-fluid product-pic " alt="" > 
                    <!-- <img src="{{ url('imgs/img_product_pic.png') }}" alt="" class="product-pic img-fluid"> -->
                </div>

            </div>
        </div>
    </div>

    <!-- features from here -->
     <section id="features">
        <div class="container text-center">
            <h2 class="text-center features-heading pt-4 mt-5">Lorem ipsum is simply dummy test.</h2>
            <span class="text-center lead">Lorem Ipsum is simply dummy text</span> <br>
            <div>
                <!-- Features - START -->
                <div class="row">
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-md-4 mt-5">
                        <div class="text-left features-container">
                            <i class="fas fa-user-shield feature-icon"></i><br>
                            <span class="feature-heading lead">Some Feature</span> <br>
                            <span class="feature-text">Some Feature Text Some Feature Text Some Feature Text</span>

                        </div>
                    </div>

                </div>
                <!-- Features - END -->

            </div>
        </div>
    </section>
    <!-- feature conntainer main -->
     <section class="feature-main-container">
        <div class="container">
        <h2 class="text-center features-heading-white pt-4 mt-5">Lorem Ipsum is simply dummy text</h2>
        <div class="feature-parent row">
            <div class="col-lg-3 col-md-3">
                <div class="feature-container p-4 mb-4 mt-2">
                   <i class="fas fa-hands-helping feature-icon"></i>
                   <h5 class="text-white mt-2">Hello, Some heading</h5>
                   <span class="text-white"> This is some feature. This is some feature.</span>
                </div>

            </div>

            <div class="col-lg-3 col-md-3">
                <div class="feature-container p-4 mb-4 mt-2">
                   <i class="fas fa-hands-helping feature-icon"></i>
                   <h5 class="text-white mt-2">Hello, Some heading</h5>
                   <span class="text-white"> This is some feature. This is some feature.</span>
                </div>

            </div>

            <div class="col-lg-3 col-md-3">
                <div class="feature-container p-4 mb-4 mt-2">
                   <i class="fas fa-hands-helping feature-icon"></i>
                   <h5 class="text-white mt-2">Hello, Some heading</h5>
                   <span class="text-white"> This is some feature. This is some feature.</span>
                </div>

            </div>

            <div class="col-lg-3 col-md-3">
                <div class="feature-container p-4 mb-4 mt-2">
                   <i class="fas fa-hands-helping feature-icon"></i>
                   <h5 class="text-white mt-2">Hello, Some heading</h5>
                   <span class="text-white"> This is some feature. This is some feature.</span>
                </div>

            </div>

        </div>

        </div>
    </section>

    <!-- pricing table -->
    <section id="plansPricing">

            <div class="container text-center">

                <h2 class="text-center features-heading pt-4 mt-5">Plans &amp; Pricing</h2>

                <div class="container mt-5">
                    <div class="pricing card-deck flex-column flex-md-row ">
                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text  shadow-sm  pink">Starter</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal text-center mb-0" data-pricing-value="15">
                                    <span class="price">Free</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>
                                 <!-- @php ($url = "/billingacc?prod_id=".request()->get('prod_id'))  -->

                              
                               <div v-if="canLogin === true">
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>
                               
                            </div>
                        </div>
                        <div class="card card-pricing popular  text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text shadow-sm   pink">Professional</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal text-center mb-0" data-pricing-value="30">
                                    ₹<span class="price">6</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>

                              
                               <div v-if="canLogin === true">
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>
                               
                            </div>
                        </div>
                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text shadow- pink">Business</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal text-center mb-0" data-pricing-value="45">
                                    ₹<span class="price">9</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>

                              
                                  <div v-if="canLogin === true">
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Try Now</button></jet-nav-link>
                               
                            </div>
                        </div>
                        <div class="card card-pricing text-center px-3 mb-4">
                            <span
                                class="h6 w-55 mx-auto px-4 py-1 rounded-bottom text shadow-sm  pink">Enterprise</span>
                            <div class="bg-transparent card-header pt-4 border-0">
                                <h1 class="h1 font-weight-normal text-center mb-0" data-pricing-value="60">
                                    ₹<span class="price">12</span><span class="h6 text-muted ml-2">/ per month</span>
                                </h1>
                            </div>
                            <div class="card-body pt-0">
                                <ul class="list-unstyled mb-4">
                                    <li>Up to 5 users</li>
                                    <li>Basic support on Github</li>
                                    <li>Monthly updates</li>
                                    <li>Free cancellation</li>
                                </ul>

                               
                                <div v-if="canLogin === true">
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe ">Subscribe</button></jet-nav-link>
                                 </div>
                              
                                <jet-nav-link v-bind:href="'organisations?product_id=1'"> <button type="button" class="btn btn-subscribe  no-underline">Try Now</button></jet-nav-link>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>


       <!-- FAQ sevtion start  -->
       <section id="faq">
        <div class="container">

            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>

            <!-- <div class="faq-header">Frequently Asked Questions</div> -->

            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of life?</label>
                    <div class="panel-content">42</div>
                </div>

                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>

                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>

        </div>
    </section>
  </div>
</template>

<style scoped>
  a:hover{
        text-decoration: none;
    }
   .img_size{
    height: auto;
    width: 155px;
   }
    :root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    .pink{
     background-color: #FF4B69;   
    }
    .text{
        color: white;
    }
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/

    .banner-img {
        width: 100%;
    }

    .img-product {
        width: 20%;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
            transition: 0.2s;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }
    }

    .product-heading {
        font-weight: 600 !important;
        font-size: 16px !important;
    }

    .trial-form {
        background: var(--white);
        border: 1px solid #D5D9DC;
        padding: 6px;
        width: 100%;
    }

    .terms-privacy-text {
        font-weight: bold;
        /* text-decoration: underline; */
    }

    .bubble-background {
        position: absolute;
        width: 25%;
    }

    .home-container {
        display: grid;
        height: 80vh;
        place-content: center;
        place-items: center;
    }

    /*Text animation - START*/

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 48%;
        }

        .cloud-divider {
            margin-top: 800px;
        }
    }

    @media only screen and (min-width: 400px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 44%;
        }

        .cloud-divider {
            margin-top: 190px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 39%;
        }

        .cloud-divider {
            margin-top: 180px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 45px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .content {
            display: block;
        }

        .home-main-text {
            margin-top: 40px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .content {
            display: block;
        }

        .home-main-text {
            margin-top: 40px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    .content {
        overflow: hidden;
        font-family: "Lato", sans-serif;
        font-size: 35px;
        line-height: 40px;
        color: var(--black);
    }

    .content__container {
        font-weight: 600;
        overflow: hidden;
        height: 40px;
        padding: 0 40px;
    }

    .content__container:before {
        content: "[";
        left: 0;
    }

    .content__container:after {
        content: "]";
        right: 50%;
    }

    .content__container:after,
    .content__container:before {
        position: absolute;
        top: 0;
        color: #16a085;
        font-size: 42px;
        line-height: 40px;
        -webkit-animation-name: opacity;
        -webkit-animation-duration: 2s;
        -webkit-animation-iteration-count: infinite;
        animation-name: opacity;
        animation-duration: 2s;
        animation-iteration-count: infinite;
    }

    .content__container__text {
        display: inline;
        float: left;
        margin: 0;
    }

    .content__container__list {
        margin-top: 0;
        padding-left: 110px;
        text-align: left;
        list-style: none;
        -webkit-animation-name: change;
        -webkit-animation-duration: 10s;
        -webkit-animation-iteration-count: infinite;
        animation-name: change;
        animation-duration: 10s;
        animation-iteration-count: infinite;
    }

    .content__container__list__item {
        line-height: 40px;
        margin: 0;
    }

    @-webkit-keyframes opacity {

        0%,
        100% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }
    }

    @-webkit-keyframes change {

        0%,
        12.66%,
        100% {
            transform: translate3d(0, 0, 0);
        }

        16.66%,
        29.32% {
            transform: translate3d(0, -25%, 0);
        }

        33.32%,
        45.98% {
            transform: translate3d(0, -50%, 0);
        }

        49.98%,
        62.64% {
            transform: translate3d(0, -75%, 0);
        }

        66.64%,
        79.3% {
            transform: translate3d(0, -50%, 0);
        }

        83.3%,
        95.96% {
            transform: translate3d(0, -25%, 0);
        }
    }

    @keyframes opacity {

        0%,
        100% {
            opacity: 0;
        }

        50% {
            opacity: 1;
        }
    }

    @keyframes change {

        0%,
        12.66%,
        100% {
            transform: translate3d(0, 0, 0);
        }

        16.66%,
        29.32% {
            transform: translate3d(0, -25%, 0);
        }

        33.32%,
        45.98% {
            transform: translate3d(0, -50%, 0);
        }

        49.98%,
        62.64% {
            transform: translate3d(0, -75%, 0);
        }

        66.64%,
        79.3% {
            transform: translate3d(0, -50%, 0);
        }

        83.3%,
        95.96% {
            transform: translate3d(0, -25%, 0);
        }
    }

    /*Text animation - END*/

    .free-trial-btn {
        width: 100%;
        border: 1px solid #FF4B69;
        background-color: #FF4B69;
        color:white; 
    }

    .product-pic {
        width: 100%;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .home-container {
            margin-top: 120px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .home-container {
            margin-top: 70px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .home-container {
            margin-top: 50px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .home-container {
            margin-top: 50px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .home-container {
            margin-top: 0px;
        }
    }

    .nav-link-header {
        color: #9c761f !important;
        font-weight: 600 !important;
    }
    .search-button {
            border: 1px solid #011969;
            font-style: normal;
            margin-left: 4px;
            font-weight: 600;
            background-color: #001969;
            color: white;
    
        }

        .search-button:hover {
            text-decoration: none;
            color: #ffffff;
        }

        /* svg */
        path {
        fill: #FF4B69;
    }

    .catalog-section {
        background-color: #FF4B69;
    }
    /* feature start */
     /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .features-heading {
            font-weight: bold;
            font-size: 38px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .features-heading {
            font-weight: bold;
            font-size: 38px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .features-heading {
            font-weight: bold;
            font-size: 40px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .features-heading {
            font-weight: bold;
            font-size: 50px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .features-heading {
            font-weight: bold;
            font-size: 50px;
        }
    }


    .feature-text {}

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .feature-icon {
            font-size: 28px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .feature-icon {
            font-size: 30px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .feature-icon {
            font-size: 32px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .feature-icon {
            font-size: 38px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .feature-icon {
            font-size: 38px;
        }
    }

    .features-container {
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
        transition: 0.4s;
    }

    .features-container:hover {
        box-shadow: 0 0 2px 10px var(--blue);
    }

    .feature-main-container{

    }
    /* feature main container */
      .feature-main-container{
            background-color: #FF4B69;
        }

        .features-heading-white{
            color: #ffffff;
            font-weight: bold;
            font-size: 50px;  
        }

        .feature-icon{
            font-size: 36px;
            color: #ffffff;
        }

        .feature-container {
            border: 2px solid #ffffff;

        }
        /* pricing style */
        /* pricing style start */

        .card-pricing .list-unstyled li {
            padding: 0.5rem 0;
            color: #6c757d;
        }

        .card {
            border-color: #6C757D;
        }

        #plansPricing {
            background-color: #EFEFEF;
        }

        .btn-subscribe{
            border: 1px solid #FF4B69;
            color: #FF4B69;
        }

        .btn-subscribe:hover{
            border: 1px solid #FF4B69;
            background-color: #FF4B69;
            color: #ffffff;
        }

        /* pricing style ends */
        /* FAQ section start */
         .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 24px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 4px;
        z-index: 5;
        font-size: 42px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }
</style>

<script>
     import { Head, Link } from '@inertiajs/inertia-vue3';
       import Navigation from "@/Layouts/Navigation.vue";
       import AppLayout from "@/Layouts/AppLayout.vue";
       import JetNavLink from '@/Jetstream/NavLink.vue'
       export default {
      
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
    }
    }
    </script>
